import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Button } from '@components/main-components/button/Button';
import { StandardModal } from '@components/main-components/modals/StandardModal';

export function ConfirmModal({
  onConfirm,
  onCancel,
  title,
  message,
  confirmText,
  cancelText,
  loading = false,
  destructive = false,
}: {
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  loading?: boolean;
  destructive?: boolean;
}) {
  return (
    <StandardModal
      bodyWithoutPadding
      bodyWithoutPaddingBottom
      bodyClassName="px-0 overflow-hidden"
      containerClassName="p-0"
      body={
        <div className="md flex flex-col gap-4 p-4 md:p-6">
          {/**
           * Title and x button
           */}
          <div className="flex items-center">
            <div className="flex-1 font-title text-title-l font-medium text-base800">{title}</div>
            <div
              className="-mx-3 -my-2 cursor-pointer rounded-full px-3 py-2 hover:bg-neutral100"
              onClick={onCancel}
            >
              <FontAwesomeIcon icon={faXmark} size="xl" className="text-neutral500" />
            </div>
          </div>

          {/**
           * Message body
           */}
          <div className="font-base text-base-l text-base800">{message}</div>

          {/**
           * Button row
           */}
          <div className="flex gap-3">
            <Button fullWidth variant="secondary" label={cancelText} onClick={onCancel} />
            <Button
              fullWidth
              variant={destructive ? 'critical' : 'primary'}
              label={confirmText}
              onClick={onConfirm}
              loading={loading}
            />
          </div>
        </div>
      }
    />
  );
}
